var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 346.5",
    style: {
      enableBackground: "new 0 0 375 346.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0033AD;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 187.5,
    cy: 173.2,
    r: 150
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.2,173.6c-0.5,8.5,6,15.7,14.5,16.2c0.3,0,0.6,0,0.9,0c8.5,0,15.4-6.9,15.4-15.4 c0-8.5-6.9-15.4-15.4-15.4C143.4,159,136.6,165.4,136.2,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,169.6c-2.7-0.2-5.1,1.9-5.2,4.7c-0.1,2.7,1.9,5.1,4.7,5.2c2.7,0.2,5.1-1.9,5.2-4.7 C83.7,172.1,81.6,169.8,78.8,169.6L78.8,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,84.3c2.4-1.2,3.4-4.3,2.2-6.7c-1.2-2.4-4.3-3.4-6.7-2.2s-3.4,4.2-2.2,6.6 C129.7,84.5,132.7,85.6,135.2,84.3C135.2,84.3,135.2,84.3,135.2,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.8,111.5c3.8-1.9,5.3-6.5,3.4-10.3c-1.9-3.8-6.5-5.3-10.3-3.4c-3.8,1.9-5.3,6.5-3.4,10.3 C142.4,111.9,147.1,113.4,150.8,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,130.2c2.9,1.9,6.8,1.1,8.8-1.8c1.9-2.9,1.1-6.8-1.8-8.8c-2.9-1.9-6.8-1.1-8.8,1.8l0,0 C94.5,124.4,95.4,128.3,98.3,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,166.9c-4.3-0.2-7.9,3-8.1,7.2s3,7.9,7.2,8.1c4.3,0.2,7.9-3,8.1-7.2l0,0 C115.1,170.8,111.9,167.1,107.6,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,218.5c-3.1,1.6-4.4,5.4-2.8,8.5c1.6,3.1,5.4,4.4,8.5,2.8c3.1-1.6,4.4-5.4,2.8-8.5l0,0 C106.1,218.2,102.3,216.9,99.2,218.5L99.2,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129,151c4.2,2.7,9.8,1.6,12.5-2.6c2.7-4.2,1.6-9.8-2.6-12.5c-4.2-2.7-9.8-1.6-12.5,2.6 C123.7,142.6,124.8,148.2,129,151L129,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.8,110.9c3.5,2.3,8.3,1.3,10.7-2.2s1.3-8.3-2.2-10.7c-3.5-2.3-8.3-1.3-10.7,2.2l0,0 C219.2,103.8,220.2,108.6,223.8,110.9L223.8,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.5,83.8c2.3,1.5,5.4,0.9,6.9-1.5s0.9-5.4-1.5-6.9s-5.4-0.9-6.9,1.4C236.5,79.2,237.2,82.3,239.5,83.8 L239.5,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.9,158.9c-8.5-0.5-15.8,6-16.2,14.5c-0.5,8.5,6,15.8,14.5,16.2c0.3,0,0.6,0,0.9,0 c8.5,0,15.4-6.9,15.4-15.4C239.5,166.1,233.1,159.3,224.9,158.9L224.9,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.9,149.9c2.6,5.2,7.9,8.5,13.8,8.5c8.5,0,15.4-6.9,15.4-15.4c0-2.4-0.5-4.8-1.6-6.9 c-3.8-7.6-13.1-10.7-20.7-6.8C155.1,133.1,152,142.3,155.9,149.9L155.9,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.5,130.2c3.1-1.6,4.3-5.4,2.7-8.5c-1.6-3.1-5.4-4.3-8.5-2.7c-3.1,1.6-4.3,5.4-2.8,8.5 C269.5,130.5,273.3,131.8,276.5,130.2L276.5,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.5,135.1c-4.4,2.3-6.3,7.7-4,12.1s7.7,6.3,12.1,4s6.3-7.7,4-12.1C247.3,134.7,241.9,132.9,237.5,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.2,81.5c3.5,0.2,6.5-2.5,6.7-6c0.2-3.5-2.5-6.5-6-6.7c-3.5-0.2-6.5,2.4-6.7,5.9 C181,78.2,183.7,81.2,187.2,81.5L187.2,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.1,121.3c5,0.3,9.3-3.5,9.5-8.5c0.3-5-3.5-9.3-8.5-9.5c-5-0.3-9.3,3.5-9.5,8.5 C178.4,116.8,182.1,121,187.1,121.3L187.1,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.2,213.6c4.4-2.3,6.3-7.7,4-12.1c-2.3-4.4-7.7-6.3-12.1-4c-4.4,2.3-6.3,7.7-4,12.1 C128.3,214,133.7,215.9,138.2,213.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,134.5c-4.6,7.1-2.7,16.6,4.4,21.3c7.1,4.6,16.6,2.7,21.3-4.4c4.6-7.1,2.7-16.6-4.4-21.3 c-2.5-1.6-5.4-2.5-8.4-2.5C200.7,127.5,195.8,130.2,193,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.7,198.8c-3.8-7.6-13.1-10.7-20.7-6.8c-7.6,3.8-10.7,13.1-6.8,20.7c3.8,7.6,13.1,10.7,20.7,6.8l0,0 c7.6-3.8,10.7-12.9,6.9-20.5C219.8,198.9,219.8,198.9,219.7,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.6,197.7c-4.2-2.7-9.8-1.6-12.5,2.6c-2.7,4.2-1.6,9.8,2.6,12.5c4.2,2.7,9.8,1.6,12.5-2.6 C252,206.1,250.8,200.5,246.6,197.7L246.6,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,174.6c0.2-4.3-3-7.9-7.2-8.1c-4.3-0.2-7.9,3-8.1,7.2s3,7.9,7.2,8.1l0,0 C272.2,182.1,275.8,178.8,276.1,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.3,169.1c-2.7-0.2-5.1,1.9-5.2,4.7s1.9,5.1,4.7,5.2c2.7,0.2,5.1-1.9,5.2-4.7 C302.2,171.6,300.1,169.3,297.3,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.3,218.5c-2.9-1.9-6.8-1.1-8.8,1.8c-1.9,2.9-1.1,6.8,1.8,8.8c2.9,1.9,6.8,1.1,8.8-1.8 S280.2,220.4,277.3,218.5L277.3,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,264.9c-2.3-1.5-5.4-0.9-6.9,1.4c-1.5,2.3-0.9,5.4,1.4,6.9c2.3,1.5,5.4,0.9,6.9-1.4l0,0 C139.1,269.5,138.4,266.4,136.1,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.4,264.4c-2.4,1.2-3.4,4.3-2.2,6.7c1.2,2.4,4.3,3.4,6.7,2.2c2.4-1.2,3.4-4.2,2.2-6.6 C245.9,264.2,242.9,263.1,240.4,264.4C240.4,264.4,240.4,264.4,240.4,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.6,214.2c4.6-7.1,2.7-16.6-4.4-21.3c-7.1-4.6-16.6-2.7-21.3,4.4c-4.7,7.1-2.7,16.6,4.4,21.3 c2.5,1.6,5.4,2.5,8.4,2.5C175,221.2,179.8,218.6,182.6,214.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,237.8c-3.5-2.3-8.3-1.3-10.7,2.2c-2.3,3.5-1.3,8.3,2.2,10.7s8.3,1.3,10.7-2.2l0,0 C156.4,244.9,155.5,240.1,151.9,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.7,267.2c-3.5-0.2-6.5,2.5-6.7,6c-0.2,3.5,2.5,6.5,6,6.7c3.5,0.2,6.5-2.4,6.7-5.9 C193.9,270.5,191.2,267.5,187.7,267.2L187.7,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.8,227.4c-5-0.3-9.3,3.5-9.5,8.5c-0.3,5,3.5,9.3,8.5,9.5c5,0.2,9.3-3.5,9.5-8.5 C196.6,232,192.8,227.7,187.8,227.4L187.8,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,237.2c-3.8,1.9-5.3,6.6-3.4,10.4s6.6,5.3,10.4,3.4c3.8-1.9,5.3-6.5,3.4-10.3 C233.3,236.8,228.6,235.2,224.8,237.2L224.8,237.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAda);
export default __webpack_public_path__ + "static/media/ADA.aa08aff9c8e286bb2a095e5a964b6755.svg";
export { ForwardRef as ReactComponent };